module.exports = __webpack_public_path__ + "img/external-content.duckduckgocom.e6c07fc8.png";